import { render, staticRenderFns } from "./BtnExcluirAcao.vue?vue&type=template&id=0489afe6&"
import script from "./BtnExcluirAcao.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirAcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports